import React, { forwardRef } from 'react';
import ProgressBar from './atoms/progressbar';
const Progress = forwardRef((props, ref) => {
    const { color, corner = 'rounded', size = 'medium', ...otherProps } = props;
    return React.createElement(ProgressBar, { "$color": color, "$corner": corner, "$size": size, ref: ref, ...otherProps });
});
export default Progress;
